import simulationIcon from "common/assets/font-awesome/simulation-case.svg";
import { CloseIcon, ToolbarIcon } from "common/assets/icons";
import { IconButton, TextButton } from "common/buttons";
import { useConfirmDialog } from "common/components/confirm-dialog/use-confirm-dialog";
import { ListItem } from "common/components/lists/ListItem";
import { contentStatusLabel } from "common/content-status";
import {
  DnDItemType,
  useDragAndDropElement,
} from "common/hooks/useDragAndDropElement";
import { urls } from "common/urls";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ListElement } from "./SimulationList";
import styles from "./SimulationList.module.css";

function getIcon(): string {
  return simulationIcon;
}

interface ListElementProps {
  element: ListElement;
  index: number;
  showIcon: boolean;
  canDrag: boolean;
  isLoading?: boolean;
  onDelete?: (contentId: string) => void;
  moveElement(dragIndex: number, hoverIndex: number): void;
  saveOrder(dragIndex: number, dropIndex: number, id: string): void;
}

export const SimulationListElement = ({
  element,
  index,
  showIcon,
  onDelete,
  canDrag,
  isLoading = false,
  moveElement,
  saveOrder,
}: ListElementProps): React.ReactElement => {
  const [ref, isDragging] = useDragAndDropElement(
    element.id,
    index,
    DnDItemType.ADMINISTRATION_LIST_ELEMENT,
    moveElement,
    saveOrder,
  );

  const [showMenu, setShowMenu] = useState(false);
  const { showConfirm, InlineConfirm } = useConfirmDialog(isLoading);

  return (
    <ListItem
      passRef={canDrag ? ref : null}
      className={styles.element}
      style={{ opacity: isDragging ? 0 : 1 }}
    >
      <div className={styles.col} style={{ width: "100%" }}>
        <div className={styles.row}>
          <Link
            to={urls.simulationCaseAdmin(element.id)}
            className={styles.link}
          >
            <div className={styles.iconAndText}>
              {showIcon && (
                <img src={getIcon()} alt="icon" className={styles.icon} />
              )}
              <div className={styles.text}>
                <span>
                  <h4 className={styles.title}>{element.title} </h4>(
                  {contentStatusLabel(element.status)})
                </span>
              </div>
            </div>
          </Link>
          {/* TODO: These buttons are hard to click because of their small size */}
          {showMenu ? (
            (InlineConfirm ?? (
              <div className={styles.buttons}>
                <Link to={urls.simulationCase(element.id)}>
                  <TextButton kind="secondary">Studentvisning</TextButton>
                </Link>

                <Link to={urls.simulationCaseAdmin(element.id)}>
                  <TextButton kind="secondary">Endre innhold</TextButton>
                </Link>

                <Link to={urls.simulationDiagnosisAdmin(element.id)}>
                  <TextButton kind="secondary">Endre quiz</TextButton>
                </Link>

                <Link to={urls.simulationCaseGenerate(element.id)}>
                  <TextButton kind="secondary">Auto-generer innhold</TextButton>
                </Link>

                <IconButton
                  icon={<CloseIcon />}
                  altText={`Lukk meny for innholdet med navn ${element.title}`}
                  onClick={() => {
                    setShowMenu(false);
                  }}
                />
              </div>
            ))
          ) : (
            <IconButton
              icon={<ToolbarIcon />}
              altText={`Åpne meny for innholdet med navn ${element.title}`}
              onClick={() => {
                setShowMenu(true);
              }}
            />
          )}
        </div>
      </div>
    </ListItem>
  );
};
